module.exports = new __parcel__URL__("Frame-2.65c33ab1.svg").toString();